<template lang="pug">

form.ui.error.form(v-on:submit.prevent="submit()")

    //- Navigation
    navigation

    //- Content
    .ui.top.attached.header Personendaten:
    update-form(
        ref="form"
        v-bind:companyModels='companies'
        v-model='model'
    )

    action-row.ui.bottom.secondary(v-on:cancel="cancel()")

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store'
    import ActionRow from '@/components/form/ActionRow'
    import UpdateForm from '@/components/persons/UpdateForm'
    import Navigation from '@/components/addresses/Navigation'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        components: { ActionRow, Navigation, UpdateForm },

        beforeRouteEnter(to, from, next) {

            return Promise.all([

                // Person laden
                store.dispatch('persons/loadOne', { id: to.params.id }),

                // Unternehmen laden
                store.dispatch('companies/loadAll')

            ]).then(next)

        },

        created() {
            // Person setzen
            this.model = store.getters['persons/byId'](this.$route.params.id)
        },

        computed: {
            companies() {
                return store.getters['companies/all']
            }
        },

        data() {
            return {
                model: {}
            }
        },

        methods: {

            cancel() {
                this.$router.push({ name: 'persons' })
            },

            persist() {
                // Speichern
                this.$refs.form.persist()

                    // Message anzeigen
                    .then(() => this.$growl.success('Person wurde aktualisiert'))

                    // Weiterleitung zur Übersicht
                    .then(() => this.$router.push({ name: 'persons' }))

                    // Fehlermeldung anzeigen
                    .catch(e => this.$growl.fatal('Person konnte nicht gespeichert werden', e))
            },

            submit() {
                this.$refs.form.validate().then(R.ifElse(R.equals(true), this.persist, this.$scrollToErrorAndFocus))
            }

        }

    }

</script>
